import React, { useContext, useEffect, useState } from "react"
import CallTableViewModel from "../../../ViewModels/CallTableViewModel"
import { APIContext } from "../../../Contexts/APIContext"
import DropdownViewModel from "../../../Contexts/ViewModels/DropdownViewModel"
import AIFlaggedIssueViewModel from "./ViewModels/AIFlaggedIssueViewModel"
import { useSnackbar } from "notistack"
import Grid from "@mui/material/Grid"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function AIFlaggedIssuesDialog(props: IFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [templateOptions, setTemplateOptions] = useState<DropdownViewModel[]>([]);
    const [sectionOptions, setSectionOptions] = useState<DropdownViewModel[]>([]);
    const [questionOptions, setQuestionOptions] = useState<DropdownViewModel[]>([]);
    const [aiFlaggedIssuesFilter, setAIFlaggedIssuesFilter] = useState<AIFlaggedIssueViewModel>(props.callTableViewModel.filters.aiFlaggedIssues);
    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
        if (props.open) {
            setAIFlaggedIssuesFilter(props.callTableViewModel.filters.aiFlaggedIssues);
        }
    }, [props.open])

    useEffect(() => {
        getTemplateOptions();
    }, []);

    useEffect(() => {
        HandleSelect('sectionId', 0);
        if (aiFlaggedIssuesFilter.templateId !== 0) getSectionOptions();
    }, [aiFlaggedIssuesFilter.templateId]);

    useEffect(() => {
        HandleSelect('questionId', 0);
        if (aiFlaggedIssuesFilter.sectionId !== 0) getQuestionOptions();
    }, [aiFlaggedIssuesFilter.sectionId]);

    //#region database calls
    const getTemplateOptions = () => {
        get('ScorecardManagement', `GetTemplateOptions?client=` + props.callTableViewModel.filters.client, (data) => {
            setTemplateOptions(data);
        });
    }

    const getSectionOptions = () => {
        get('ScorecardManagement', `GetSectionOptions?templateId=` + aiFlaggedIssuesFilter.templateId, (data) => {
            setSectionOptions(data);
        });
    }

    const getQuestionOptions = () => {
        get('ScorecardManagement', `GetQuestionOptions?sectionId=` + aiFlaggedIssuesFilter.sectionId, (data) => {
            setQuestionOptions(data)
        });
    }
    //#endregion

    const Confirm = () => {
        if (aiFlaggedIssuesFilter.templateId !== 0 && aiFlaggedIssuesFilter.sectionId !== 0 && aiFlaggedIssuesFilter.questionId !== 0) {
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.aiFlaggedIssues = aiFlaggedIssuesFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })

            props.setOpen(false);
        }
        else {
            enqueueSnackbar("All values must be selected to confirm", { variant: 'warning' });
        }
    }

    const HandleSelect = (key: string, value: number, questionText?: string) => {
        setAIFlaggedIssuesFilter({
            ...aiFlaggedIssuesFilter,
            [key]: value
        });
    }

    return (
        <Dialog onClose={() => props.setOpen(false)} open={props.open} fullWidth maxWidth="sm">
            <DialogTitle>
                QA-I Flagged Issues
            </DialogTitle>
            <DialogContent>
                {templateOptions.length > 0 ?
                    <Grid container style={{ width: '100%' }}>
                        <Grid size={12}>
                            <InputLabel>Template</InputLabel>
                            <TextField
                                select
                                name="templateId"
                                value={aiFlaggedIssuesFilter.templateId}
                                onChange={(e) => HandleSelect(e.target.name, Number(e.target.value))}
                                fullWidth
                            >
                                {templateOptions.map((template: DropdownViewModel) => {
                                    return (<MenuItem key={template.id} value={template.id}>{template.label}</MenuItem>);
                                })}
                            </TextField>
                        </Grid>
                        {aiFlaggedIssuesFilter.templateId !== 0 &&
                            <Grid size={12}>
                                <InputLabel>Section</InputLabel>
                                <TextField
                                    select
                                    name="sectionId"
                                    value={aiFlaggedIssuesFilter.sectionId}
                                    onChange={(e) => HandleSelect(e.target.name, Number(e.target.value))}
                                    fullWidth
                                    disabled={aiFlaggedIssuesFilter.templateId === 0}
                                >
                                    {sectionOptions.length > 0 && sectionOptions.map((section: DropdownViewModel) => {
                                        return (<MenuItem key={section.id} value={section.id}>{section.label}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {aiFlaggedIssuesFilter.sectionId !== 0 &&
                            <Grid size={12}>
                                <InputLabel>Question</InputLabel>
                                <TextField
                                    select
                                    name="questionId"
                                    value={aiFlaggedIssuesFilter.questionId}
                                    onChange={(e) => HandleSelect(e.target.name, Number(e.target.value), questionOptions.filter(f => f.id == Number(e.target.value))[0].label)}
                                    fullWidth
                                    disabled={aiFlaggedIssuesFilter.sectionId === 0}
                                >
                                    {questionOptions.length > 0 && questionOptions.map((question: DropdownViewModel) => {
                                        return (<MenuItem key={question.id} value={question.id}>{question.label}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                    </Grid>
                    :
                    <p>This AI Filter Is Not Used By This Client</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                {templateOptions.length > 0 &&
                    <Button onClick={Confirm} color="primary">Confirm</Button>
                }
            </DialogActions>
        </Dialog >
    )
}